import { AuthService } from './../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { AiChatService } from 'src/app/services/ai-chat.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  private storage!: Storage;
  public user: any;
  public systemType: any;

  constructor(
    private authService:AuthService,
    private aiChatService: AiChatService
  ) {
    this.storage = window.sessionStorage
  }

  ngOnInit(): void {
    const item = this.storage.getItem('user');
    this.user = item ? JSON.parse(item) : {};
    this.systemType = this.storage.getItem('systemType');
  }

  getAuthoritiesName(): string {
    let authorite = 'Cliente';
    this.user.authorities.forEach((item: string) => {
      switch (item) {
        case 'ROLE_ADMIN':
          authorite = 'Admin';
          break;
        case 'ROLE_GEOMONITORING_ADMIN':
          authorite = 'Admin';
          break;
        default:
          authorite = 'Cliente';
      }
    });
    return authorite;
  }

  openAiChat(): void {
    this.aiChatService.toggleChat(true);
  }

  logout(){
    this.authService.logout()
  }
}
